export default class VideoRaceInfo {
  name;

  trackName;

  trackId;

  trackAbbr;

  perfAbbr;

  nextRace;

  timeLabel;

  streamName;

  streamCode;

  status;

  featured;

  channel;

  isHD;

  isFlash;

  constructor(
    name,
    trackAbbr,
    perfAbbr,
    nextRace,
    timeLabel,
    streamName,
    status,
    featured,
    channel = "",
    isHD = false,
    isFlash = true
  ) {
    this.name = name;
    this.trackName = name;
    this.trackId = `${trackAbbr}_${nextRace}`;
    this.trackAbbr = trackAbbr;
    this.perfAbbr = perfAbbr;
    this.nextRace = nextRace;
    this.streamName = streamName;
    this.streamCode = streamName;
    this.timeLabel = timeLabel;
    this.status = status;
    this.featured = featured;
    this.channel = channel;
    this.isHD = isHD;
    this.isFlash = isFlash;
  }
}
